import * as yup from 'yup';

function createYupSchema(schema, config) {
  const validator = yup
    .number()
    .transform((v, o) => (o === '' ? null : parseInt(o)))
    .notRequired()
    .nullable()
    .min(config.minValidation ? config.minValidation : 0)
    .max(config.maxValidation ? config.maxValidation : 999999999);
  schema[config.id] = validator;
  return schema;
}

export function getYupSchema(data) {
  let schema;
  if (data) {
    schema = data.reduce(createYupSchema, {});
    return yup.object().shape(schema);
  }
  return {};
}
